// SSE 帧的增量解析，纯逻辑无副作用
// 注意，只处理 \n 与 \r\n 行结束，后端不会产生孤立的 \r

export interface SseEvent {
  // 事件名，缺省为 message，这是 SSE 规范的语义
  event: string;
  // 事件 id，服务端游标，重连时原样带回
  id?: string;
  // 多个 data 行按规范拼接为 \n 连接的单字符串
  data: string;
}

export class SseFrameParser {
  private buffer = '';
  private dataLines: string[] = [];
  private eventType = '';
  private eventId: string | undefined;

  // 喂入任意大小的文本 chunk，返回这段 chunk 里完整结束的事件
  push(chunk: string): SseEvent[] {
    this.buffer += chunk;
    const events: SseEvent[] = [];
    let idx: number;
    while ((idx = this.buffer.indexOf('\n')) !== -1) {
      let line = this.buffer.slice(0, idx);
      this.buffer = this.buffer.slice(idx + 1);
      if (line.endsWith('\r')) {
        line = line.slice(0, -1);
      }

      if (line === '') {
        // 空行即事件边界，没有任何 data 行的事件不派发，比如纯心跳或纯 id
        if (this.dataLines.length > 0) {
          events.push({
            event: this.eventType || 'message',
            id: this.eventId,
            data: this.dataLines.join('\n'),
          });
        }
        this.dataLines = [];
        this.eventType = '';
        this.eventId = undefined;
        continue;
      }

      // 注释行，服务端的心跳保活
      if (line.startsWith(':')) {
        continue;
      }

      let field: string;
      let value: string;
      const colon = line.indexOf(':');
      if (colon === -1) {
        field = line;
        value = '';
      } else {
        field = line.slice(0, colon);
        value = line.slice(colon + 1);
        if (value.startsWith(' ')) {
          value = value.slice(1);
        }
      }

      if (field === 'data') {
        this.dataLines.push(value);
      } else if (field === 'event') {
        this.eventType = value;
      } else if (field === 'id') {
        this.eventId = value;
      }
      // retry 等其余字段忽略
    }
    return events;
  }
}
